import MdaeCopyText from "./component";
export default MdaeCopyText;

